import React from 'react'
import { FieldHint, QuantitySummary } from '../styles'

const number = (value: number) => value.toLocaleString('en-US')

export const QuantityProgress = ({
  planned,
  received,
  expected,
  additional = 0,
}: {
  planned: number
  received: number
  expected?: number
  additional?: number
}) => (
  <>
    {additional !== 0 && expected !== undefined ? (
      <FieldHint>
        Expected {number(expected)} + Additional {number(additional)}
      </FieldHint>
    ) : null}
    <QuantitySummary>
      <div>
        <dt>Planned</dt>
        <dd>{number(planned)}</dd>
      </div>
      <div>
        <dt>Received</dt>
        <dd>{number(received)}</dd>
      </div>
      <div>
        <dt>{received > planned ? 'Over plan' : 'Remaining'}</dt>
        <dd>{number(Math.abs(planned - received))}</dd>
      </div>
    </QuantitySummary>
  </>
)
